import { ClearCircle } from '@ori-ui/icons';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';
import React from 'react';

import { useTranslations } from '../../hooks';
import { Header, Root, TextInfo } from '../Thanks/styles';
import { REQUEST_FAILED } from './constants';
import { IconWrap } from './styles';

export const RequestFailed: FC = () => {
  const { getTestId } = useTestId();
  const { translations } = useTranslations();

  return (
    <Root data-testid={getTestId(REQUEST_FAILED)}>
      <IconWrap>
        <ClearCircle fontSize="inherit" />
      </IconWrap>
      <Header>{translations.requestFailed}</Header>
      <TextInfo>{translations.pleaseTryAgainLater}</TextInfo>
    </Root>
  );
};
